import React from 'react'
import { Form } from 'react-bootstrap'

const LabeledInput = ({
    label,
    children,
    iconComponent,
    iconSize = 30
}) => {
    const IconComponent = iconComponent
    return (
        <Form.Group>
            <Form.Label>
                {IconComponent && <IconComponent size={iconSize} />}
                <span style={{ paddingLeft: IconComponent ? '10px' : '0px'}}>{label}</span>
            </Form.Label>
            {children}
        </Form.Group>
    )
}

export default LabeledInput